import { render, staticRenderFns } from "./BeConfirmPhoneModal.vue?vue&type=template&id=bc29b66e&scoped=true"
import script from "./BeConfirmPhoneModal.vue?vue&type=script&lang=js"
export * from "./BeConfirmPhoneModal.vue?vue&type=script&lang=js"
import style0 from "./BeConfirmPhoneModal.vue?vue&type=style&index=0&id=bc29b66e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc29b66e",
  null
  
)

export default component.exports